import gql from 'graphql-tag';

const UPDATE_SLA_CONFIG = gql`
  mutation updateSlaConfig($data: SlaConfigUpdateInput!, $where: SlaConfigWhereUniqueInput!) {
    updateSlaConfig(data: $data, where: $where) {
      id
      requestType
      recommendedDays
      createdAt
      updatedAt
    }
  }
`;

export default UPDATE_SLA_CONFIG;
